import { buildClassMap } from './druid/utilities/index';
import { AnimationStyles } from './druid/styles/index';
import { IAnimationStyles } from './druid/interfaces/index';

/**
 * {@docCategory AnimationClassNames}
 */
export const AnimationClassNames: { [key in keyof IAnimationStyles]?: string } = buildClassMap(AnimationStyles);
